import { useQuery } from "react-query";
import Cookies from "js-cookie";
import { serverBaseUrl } from "../config/envs";

const getAllStandardFields = async (token) => {
  let headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const url = new URL(`${serverBaseUrl}/get_standard_fields`);

  try {
    const response = await fetch(url.toString(), { headers });

    if (!response.ok) {
      let errorData = {
        status: response?.status,
        message: response?.statusText,
      };

      try {
        const json = await response.json();
        errorData.message = json.message || errorData.message;
        errorData.messageCode = json.messageCode;
        errorData.data = json.data;
        errorData.success = json.success;
      } catch (jsonError) {
        console.error("Failed to parse JSON error response:", jsonError);
      }

      throw new Error(JSON.stringify(errorData));
    }

    const data = await response.json();

    return data?.data;
  } catch (error) {
    console.log(error, "from catch");
    throw error;
  }
};

export const useGetAllStandardFields = () => {
  const token = Cookies.get("token");

  return useQuery(["get_fields", token], () => getAllStandardFields(token), {
    refetchOnWindowFocus: false,
    retry: false,
    keepPreviousData: true,
  });
};
